import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _regeneratorRuntime from "@babel/runtime/regenerator";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { axiosBeelineRequest } from '@beef/utils';
import qs from 'query-string';
import { ESberPaymentStatusConstant } from "../../../../checkUrl/constants";
import { Content } from "../../../../getContent/Content";
import { getTransactionState, setTransactionState } from "../../../transaction";
import { getRequestIds } from "../../../transaction/utils";
import { sessionStateMap } from "../../../../checkUrl/persistence/map.dev";
import { getIsSmsStatusReceived, getUrl } from "../../utils";
export var SBER_ENDPOINTS = {
  sberRequestInfo: '/api/sberpay/content/',
  sberBinding: '/api/sberpay/binding/',
  sberStatus: '/api/sberpay/payment/status/',
  payment: '/api/sberpay/payment/'
};
export var sberPaymentRequest = /*#__PURE__*/function () {
  var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(_ref) {
    var ctn, fromCtn, bindingId, sum, captcha, smsCode, smsData, _yield$axiosBeelineRe, _yield$axiosBeelineRe2, _yield$axiosBeelineRe3, data, isCaptchaError, responseStatus, _ref3, status, verificationId, externalId, id, isSuccessfulResponseWithoutOrderId, isUnsuccessfulResponseWithoutStatus;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          ctn = _ref.ctn, fromCtn = _ref.fromCtn, bindingId = _ref.bindingId, sum = _ref.sum, captcha = _ref.captcha, smsCode = _ref.smsCode;
          // FIXME: Add failurl and success url
          smsData = getTransactionState();
          _context.next = 4;
          return axiosBeelineRequest({
            method: 'post',
            url: SBER_ENDPOINTS.payment,
            originalResponse: true,
            data: qs.stringify(_objectSpread(_objectSpread({}, getRequestIds(smsData, typeof smsCode === 'number')), {}, {
              failUrl: getUrl([[ESberPaymentStatusConstant.StatusParameter, ESberPaymentStatusConstant.Failure]]),
              returnUrl: getUrl([[ESberPaymentStatusConstant.StatusParameter, ESberPaymentStatusConstant.Success]]),
              backToShopUrl: getUrl([]),
              ctn: ctn,
              sum: sum,
              fromCtn: fromCtn,
              bindingId: bindingId,
              smsCode: smsCode,
              captcha: captcha,
              createBinding: !bindingId && Content.getInstance().getData().sberPayPopup.request.createBinding
            })),
            headers: {
              'Content-Type': 'application/x-www-form-urlencoded'
            }
          });
        case 4:
          _yield$axiosBeelineRe = _context.sent;
          _yield$axiosBeelineRe2 = _yield$axiosBeelineRe.data;
          _yield$axiosBeelineRe3 = _yield$axiosBeelineRe2 === void 0 ? {} : _yield$axiosBeelineRe2;
          data = _yield$axiosBeelineRe3.data;
          isCaptchaError = _yield$axiosBeelineRe3.isCaptchaError;
          responseStatus = _yield$axiosBeelineRe.status;
          _ref3 = data !== null && data !== void 0 ? data : {}, status = _ref3.status, verificationId = _ref3.verificationId, externalId = _ref3.externalId, id = _ref3.id;
          isSuccessfulResponseWithoutOrderId = !!status && !getIsSmsStatusReceived(status) && !(data !== null && data !== void 0 && data.orderId) && responseStatus === 200;
          if (!isSuccessfulResponseWithoutOrderId) {
            _context.next = 14;
            break;
          }
          throw new Error('no order id provided');
        case 14:
          isUnsuccessfulResponseWithoutStatus = responseStatus !== 200 && !status;
          if (!isUnsuccessfulResponseWithoutStatus) {
            _context.next = 17;
            break;
          }
          throw new Error('unsuccessful response without status');
        case 17:
          _context.next = 19;
          return setTransactionState({
            verificationId: verificationId,
            externalId: externalId
          }, status || undefined);
        case 19:
          sessionStateMap.sberPayId.save(id);
          return _context.abrupt("return", {
            data: data,
            isCaptchaError: isCaptchaError,
            status: status
          });
        case 21:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));
  return function sberPaymentRequest(_x) {
    return _ref2.apply(this, arguments);
  };
}();